import { createPlaceholderAdapter } from './placeholders.svelte.js';
function measure(container) {
    // offset sizes: the client rect is scaled by active CSS transforms, which the
    // layout-driven ResizeObserver would never fire to correct after mount
    return { width: container.offsetWidth, height: container.offsetHeight };
}
function withSize(props, measured) {
    return {
        ...props,
        width: props.width === undefined ? measured.width : props.width,
        height: props.height === undefined ? measured.height : props.height
    };
}
/**
 * Mounts a chart into `container` and keeps it sized: explicit `width`/`height`
 * props always win; whichever dimension is omitted tracks the container's own
 * size (via ResizeObserver, where available).
 */
export function mountChartHost(create, container, props, componentContext) {
    const placeholders = createPlaceholderAdapter(componentContext);
    let lastProps = placeholders.transform(props);
    let measured = measure(container);
    const chart = create(container, withSize(lastProps, measured));
    const detachPlaceholders = placeholders.attach(container);
    let observer = null;
    if (typeof ResizeObserver !== 'undefined') {
        observer = new ResizeObserver(() => {
            const next = measure(container);
            if (next.width === measured.width && next.height === measured.height) {
                return;
            }
            measured = next;
            if (lastProps.width === undefined || lastProps.height === undefined) {
                chart.replace(withSize(lastProps, measured));
            }
        });
        observer.observe(container);
    }
    return {
        update(nextProps) {
            lastProps = placeholders.transform(nextProps);
            chart.replace(withSize(lastProps, measured));
        },
        refresh() {
            chart.refresh();
        },
        destroy() {
            if (observer) {
                observer.disconnect();
                observer = null;
            }
            chart.destroy();
            detachPlaceholders();
            placeholders.destroy();
        }
    };
}
